<template>
  <div
    class="wt2-produced-content"
    :class="{ '-open-panel': isActionPanelOpen }"
  >
    <wt-player-video
      :toggle-play-on-space="!isActionPanelPopupIsOpen"
      :timeout-control-time="timeoutControlTime"
      @played="onVideoPlay"
      @paused="onVideoPause"
    >
      <wt-volume-control group="produced">
        <video
          ref="video"
          preload="metadata"
          :poster="mixinSrc(video.posterPath)"
        >
          <source :src="mixinSrc(videoPath)" type="video/mp4" />
        </video>
      </wt-volume-control>
    </wt-player-video>

    <transition name="wt2-sliding">
      <div v-show="isActionPanelOpen">
        <wt-base-panel :on-hide="hideActionPanel">
          <produced-panel
            :video="video"
            :modal="modal"
            @pausevideo="pauseVideo"
            @openpopup="changeActionPanelPopupStatus(true)"
            @closepopup="changeActionPanelPopupStatus(false)"
          ></produced-panel>
        </wt-base-panel>
      </div>
    </transition>
  </div>
</template>

<script>
import ProducedPanel from 'v/Produced/ProducedPanel.vue';
import PopupActionContentMixin from 'mixins/PopupActionContent.vue';

export default {
  mixins: [PopupActionContentMixin],

  props: {
    video: {
      type: Object,
      required: true,
    },

    modal: {
      type: Boolean,
      default: false,
    },

    timeoutControlTime: {
      type: Number,
      default: 2000,
    },

    storyboard: {
      type: Boolean,
      default: false,
    },
    canPlay: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    canPlay(value) {
      this.changeActionPanelPopupStatus(!value);
    },
  },

  computed: {
    videoPath() {
      return this.video.videoPath || this.video.videoUrl;
    },
    panelComponent() {
      if (this.storyboard) {
        return 'storyboard-panel';
      }
      return 'produced-panel';
    },
  },

  components: {
    ProducedPanel,
  },
};
</script>
